type FormSubmitOptions = {
    method?: 'GET' | 'POST';
    body?: Record<string, string>;
};

function appendInput(form: HTMLFormElement, name: string, value: string): void {
    const input = window.document.createElement('input');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    input.setAttribute('type', 'hidden');

    form.appendChild(input);
}

export function submitForm(url: string, options?: FormSubmitOptions): void {
    const form = window.document.createElement('form');
    form.setAttribute('action', url);
    form.setAttribute('method', options?.method ?? 'POST');
    form.setAttribute('style', 'display:none');

    Object.entries(options?.body ?? {}).forEach(([key, value]) => {
        appendInput(form, key, value);
    });

    document.body.appendChild(form);
    form.submit();
}
